export enum DomExt { DOM, EXT}
export interface ITeam {
    Idt: number;
    Nom: string;
    DomExt: DomExt;
    BetScore?: number; // Add BetScore property
    Color: string;
}